var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNumber7(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 121,
    viewBox: "0 0 63 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33873 120.31L1.59167 119.456L3.72692 115.011L5.47391 115.845L5.39631 115.981H5.43511L3.3193 120.291L3.33873 120.31ZM9.76383 107.324L8.01677 106.47L12.3261 97.7736L14.0731 98.6277L9.76383 107.324ZM18.363 89.9316L16.616 89.0775L20.9253 80.3812L22.6723 81.2353L18.363 89.9316ZM26.9621 72.5391L25.2151 71.685L29.5244 62.9888L31.2714 63.8429L26.9621 72.5391ZM35.5613 55.1467L33.8143 54.2926L38.1236 45.5964L39.8705 46.4504L35.5613 55.1467ZM44.1605 37.7543L42.4134 36.9002L46.7033 28.2039L48.4503 29.058L44.1605 37.7543ZM52.7596 20.3619L51.0126 19.5078L55.3219 10.8115L57.0689 11.6656L52.7596 20.3619ZM61.3587 2.96938L59.9029 2.25118H52.7984V0.310059H62.6593L61.3393 2.96938H61.3587ZM43.0928 2.25118H33.3872V0.310059H43.0928V2.25118ZM23.6816 2.25118H13.976V0.310059H23.6816V2.25118ZM4.27043 2.25118H0V0.310059H4.27043V2.25118Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNumber7);
export default __webpack_public_path__ + "static/media/NUMBER_7.0ff6f7bfe07c7dcd17247dfa84595505.svg";
export { ForwardRef as ReactComponent };